import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useState } from "react";
import "./App.css";
import Login from "./auht/Login";
import Register from "./auht/Register";
import Protected from "./auht/Producted";
import RoutePage from "./page/RouterPage";
import HomeDemo from "./page/HomeDemo";
import usePushNotifications from "./utils/notificationManager"; // senin hook'un
import ClassRoomPayment from "./CommanComponents/ClassRoomPayment ";
import Vocabulary from "./page/Vocabulary";
import Grammar from "./page/Grammar";
import Reading from "./page/Reading_1";
import Speaking from "./page/Speaking_1";
import StudentDetail from "./teacher/StudentDetail";
import Forgotpassword from "./auht/Forgotpassword";
import Verification from "./auht/Verification";
import AydınlatmaMetni from "./footer/AydınlatmaMetni";
import GizlilikPolitikası from "./footer/GizlilikPolitikası";
import KullanımSartları from "./footer/KullanımSartları";
import SatışSözleşmesi from "./footer/SatışSözleşmesi";
import IptalPolitikası from "./footer/IptalPolitikası";
import AboutPage from "./page/AboutPage";
import ResetPassword from "./auht/ResetPassword";
import PWAInstallPrompt from "./CommanComponents/PWAInstallPrompt";
import BackGroundColor from "./CommanComponents/BackGroundColor";
import CartPage from "./page/CartPage";
import ExtraPage from "./page/extraPage";
import ExtraTaskPage from "./page/ExtraTaskPage";

function App() {
  return (
    <Routes>
      {/* Public route'lar - Token kontrolü YOK */}
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/verification" element={<Verification />} />
      <Route path="/forgat_password" element={<Forgotpassword />} />
      <Route path="/reset_password/:token" element={<ResetPassword />} />
      {/* Korumalı route'lar - Token kontrolü VAR */}
      <Route element={<RouteControl />}>
        <Route path="/" element={<HomeDemo />} />
        <Route path="/routePage" element={<RoutePage />} />
        <Route path="/protected" element={<Protected />} />
        <Route path="/purchase" element={<ClassRoomPayment />} />
        <Route path="/vocabulary" element={<Vocabulary />} />
        <Route path="/cartPage" element={<CartPage />} />
        <Route path="/extraPage" element={<ExtraPage />} />
        <Route path="/ExtraTaskPage" element={<ExtraTaskPage />} />
        <Route path="/grammar" element={<Grammar />} />
        <Route path="/reading" element={<Reading />} />
        <Route path="/speaking" element={<Speaking />} />
        <Route path="/studentDetail" element={<StudentDetail />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/kvkk" element={<AydınlatmaMetni />} />
        <Route path="/gizlilik" element={<GizlilikPolitikası />} />
        <Route path="/kullanim-sartlari" element={<KullanımSartları />} />
        <Route path="/mesafeli-satis" element={<SatışSözleşmesi />} />
        <Route path="/iade" element={<IptalPolitikası />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;

export const RouteControl = () => {
  const token = localStorage.getItem("token");
  const [isNight, setIsNight] = useState(false);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="relative">
      {/* PWA Popup'ını buraya ekliyoruz */}
      <PWAInstallPrompt />

      <div className="fixed inset-0 z-0">
        <BackGroundColor isNight={isNight} setIsNight={setIsNight} />
      </div>
      <div
        className="relative z-10 flex flex-col justify-center items-center m-1 md:mt-14 md:mx-30 md:mb-6 rounded-2xl gap-4"
        style={{
          fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};
